import { Icon } from '@iconify/react/dist/iconify.js';
import React from 'react';
import { Link } from 'react-router-dom';

const ProjectCard = ({ project }) => {
    return (
        <div className="mb-40">
            <div className="card h-100 radius-12">
                {/* Square Image Container */}
                <div style={{
                    width: '100%',
                    paddingBottom: '40%', // Maintain aspect ratio 1:1
                    position: 'relative',
                    overflow: 'hidden',
                }}>
                    <img
                        src={project.picture}
                        alt={project.name}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover', // Scale and crop to fit
                        }}
                    />
                </div>

                <div className="card-body p-20 text-left">
                    <div className="d-flex justify-content-between align-items-left"> {/* Added flex container */}
                        <div> {/* Wrapper for project details */}
                            <h5 className="card-title text-lg text-primary-light mb-6">
                                {project.name}
                            </h5>
                            <p className="card-text text-neutral-600">
                                {project.developer?.name}
                            </p>
                        </div>
                        <div> {/* Wrapper for developer logo */}
                            <img
                                src={project.developer?.logo} // Assuming developer object has a logo property
                                alt={`${project.developer?.name} logo`}
                                style={{
                                    width: '50px', // Adjust size as needed
                                    height: '50px',
                                    borderRadius: '50%', // Make it circular
                                }}
                            />
                        </div>
                    </div>
                   {/* Added a margin-top for spacing */}
                   <Link
                        to={`/units/${project.id}`}
                        className="btn btn-primary-600 px-90 py-10 d-inline-flex align-items-left gap-2 mt-3" 
                    >
                        <Icon icon="iconamoon:arrow-right-2" className="text-xl" />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ProjectCard;